// The console's i18next instance: the platform catalogues plus the surface's own namespaces — the
// console's, and in the HQ build HQ's — all from `@clavian/i18n` (copy lives there and nowhere else,
// spec/21 §3).

import { createI18n, resolveLocale, type CreateI18nOptions, type VenueLocale } from '@clavian/i18n';
import { consoleResources } from '@clavian/i18n/console';
import { initReactI18next } from '@clavian/i18n/react';

export type ConsoleI18n = ReturnType<typeof createI18n>;

export function createConsoleI18n(
  language?: string,
  resources: NonNullable<CreateI18nOptions['extraResources']> = consoleResources,
): ConsoleI18n {
  const preferred = language ?? (typeof navigator === 'undefined' ? undefined : navigator.language);
  return createI18n({ language: resolveLocale(preferred), extraResources: resources, use: [initReactI18next] });
}

/**
 * The country a new address starts in. The brand configuration's default country (F-ORG-04, #468)
 * once the console can read it; until then the launch market's (spec/03 §10).
 */
export const DEFAULT_COUNTRY = 'IN';

/**
 * Money, dates and business days follow the venue (spec/12 §7). Until a screen formats either, the
 * console's frame uses the launch market's defaults (spec/03 §10: INR, en-IN, Asia/Kolkata).
 */
export const DEFAULT_VENUE_LOCALE: VenueLocale = { locale: 'en-IN', timeZone: 'Asia/Kolkata', currency: 'INR' };
